<template>
  <div id="main">
    <v-container fluid grid-list-md>
      <v-layout row>
        <!-- Show larger header in larger screen. Display in 3 lines -->
        <v-flex md12 offset-md2 hidden-sm-and-down>
          <p class="headingText">Hey, take a minute and</p>
          <p class="middleText">check out our projects &</p>
          <p class="headingText">concepts.</p>
          <p class="supportingText">Get in Touch With Us.</p>
        </v-flex>
        <!-- Show smaller header in smaller screen -->
        <v-flex xs12 hidden-md-and-up>
          <p class="smallHeadingText">
            Hello, take a minute and check out our projects & Concepts.
          </p>
          <p class="smallSupportingText">Get in Touch With Us.</p>
        </v-flex>
      </v-layout>
      <!-- Button arrangement -->
      <div class="button-group hidden-sm-and-down">
        <button
          v-for="(val, key) in option.getFilterData"
          :key="key"
          class="button-portfolio"
          :class="[key === filterOption ? 'is-checked' : '']"
          @click="filter(key)"
        >
          {{ key }}
        </button>
      </div>

      <v-layout row wrap align-center class="hidden-md-and-up">
        <v-flex xs12>
          <v-select
            v-model="activeBtn"
            :items="btnOption"
            :menu-props="{ maxHeight: '400' }"
            hint="Pick your category"
            persistent-hint
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout v-if="!mountedStatus" row wrap align-center text-xs-center>
        <v-flex xs12>
          <div class="spinner"></div>
        </v-flex>
      </v-layout>
    </v-container>

    <isotope
      :class="{ displayNone: isDisplayNone }"
      ref="cpt"
      :item-selector="'element-item'"
      :list="portfolioList"
      :options="option"
      @filter="filterOption = arguments[0]"
      v-images-loaded:on.progress="layout"
    >
      <div
        v-for="(element, index) in portfolioList"
        class="item-shuffle"
        :key="index"
      >
        <div class="previewImg" @click="goToShowCase(element)">
          <img class="leImg" :src="element.coverPic" alt="Not found" />
          <p class="previewText text-xs-center">{{ element.name }}</p>
        </div>
      </div>
    </isotope>
    <v-snackbar :color="snackbarColour" bottom v-model="snackbar" dark>
      <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
      <div>{{ snackbarText }}</div>
      <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import db from "@/firebase/init";
import isotope from "vueisotope";
import imagesLoaded from "vue-images-loaded";
var count = 0;

export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Everowl Technologies",
    // all titles will be injected into this template
    titleTemplate: "Portfolio | Build your own website or application | %s",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Spend some time and take a look on our portfolio, help yourself and get inspired to assess your potential goal getters.",
      },
      {
        name: "keywords",
        content:
          "everowl portfolio, mobile application portfolio, website portfolio, mobile application development kuala lumpur, website design kuala lumpur, web design malaysia",
      },
    ],
  },

  directives: {
    imagesLoaded,
  },
  components: {
    isotope,
  },
  data() {
    return {
      isDisplayNone: true,
      activeBtn: "All",
      btnOption: ["All", "Website", "Mobile Application", "Concept"],
      mountedStatus: false,
      portfolioList: [],
      counter: 0,
      selected: null,
      filterOption: "All",
      option: {
        itemSelector: ".element-item",
        getFilterData: {
          All: function() {
            return true;
          },
          "Mobile Application": function(el) {
            return el.type === "Mobile Application";
          },
          Website: function(el) {
            return el.type === "Website";
          },
          Concept: function(el) {
            return el.type === "Concept";
          },
        },
      },
      // For snackbar
      snackbar: false,
      snackbarColour: "",
      snackbarText: "",
    };
  },
  watch: {
    activeBtn(val) {
      this.filter(val);
    },
  },
  methods: {
    imageProgress(instance, image) {
      this.$refs.cpt.layout("masonry");
      this.$refs.cpt.filter("All");
      const result = image.isLoaded ? "loaded" : "broken";
    },
    layout() {
      this.counter = this.counter + 1;
      if (this.portfolioList.length === this.counter) {
        this.$refs.cpt.layout("masonry");
        setTimeout(() => {
          this.mountedStatus = true;
          this.isDisplayNone = false;
        }, 500);
      }
    },
    filter(key) {
      this.$refs.cpt.filter(key);
    },
    getPortfolioList() {
      db.collection("portfolios")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var updDoc = doc.data();
            updDoc["uniquePortfolioID"] = doc.id;
            this.portfolioList.push(updDoc);
          });
        })
        .catch((error) => {
          this.snackbarColour = "error";
          this.snackbar = true;
          this.snackbarText = "Error: " + error;
          console.log("Error getting documents: ", error);
        });
    },
    goToShowCase(element) {
      this.$store.commit("setCurrentPortfolioViewed", element);

      this.$router.push({
        path: "showcase",
      });
    },
  },
  mounted() {
    this.getPortfolioList();
  },
};
</script>

<style>
.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  margin: 100px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}

.item-shuffle {
  padding: 10px;
  width: 33.33%;
  height: auto;
  margin-bottom: 10px;
  box-sizing: border-box;
  color: #333;
  margin-top: -10px;
}

.isoDefault {
  min-height: 210px;
}

/* ---- button ---- */
.button-portfolio:focus {
  outline: 0;
}

.button-portfolio {
  display: inline-block;
  padding: 12px 30px;
  line-height: 1.5em;
  min-width: 88px;
  text-transform: uppercase;
  text-decoration: none;
  webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  background: transparent;
  border: none;
  color: #222;
  font-size: 12px;
  text-shadow: 0 1px white;
  cursor: pointer;
}

.button-portfolio:hover {
  text-shadow: 0 1px hsla(0, 0%, 0%, 0.5);
  color: #222;
}

.button-portfolio.is-checked {
  background-color: #222;
  color: rgb(255, 255, 255);
  border-radius: 25px !important;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}

.button-portfolio:active {
  /* box-shadow: inset 0 1px 10px hsla(0, 0%, 0%, 0.8); */
}

/* ---- button-group ---- */
.button-group {
  margin-bottom: 20px;
}

.button-group:after {
  content: "";
  display: block;
  clear: both;
}

.button-group .button-portfolio {
  float: right;
  border-radius: 50%;
  margin-left: 0;
  margin-right: 5px;
}

.button-group .button-portfolio:first-child {
  margin-right: 20px;
}

/* Hide text in pictures (before hover) */
.previewImg p.previewText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
/* Show text in pictures (after hover) */
.previewImg:hover p.previewText {
  color: white !important;
  font-size: 36px !important;
  font-weight: bold;
  opacity: 1;
  cursor: pointer;
}

/* Preset preview gradient (before hover) */
.previewImg {
  background: -webkit-linear-gradient(
    -45deg,
    #e9168c,
    #9012fe 50%,
    #006cff 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(-45deg, #e9168c, #9012fe 50%, #006cff 100%);
  background-size: 400% 400%;
  position: relative;
  cursor: pointer;
  transition: 0.5s all;
}
/* Display preview gradient (after hover) */
.previewImg:hover {
  background-position: 100% 100%;
}

/* Display image and transition to preview gradient */
.leImg {
  background: #fff;
  z-index: 1;
  opacity: 0.9;
  transition: 0.5s all;
  width: 100%;
  height: auto;
}
/* Darken the image so that the text can be seen clearly */
.leImg:hover {
  opacity: 0.3;
}

p.headingText {
  font-family: Lato !important;
  font-size: 46px !important;
  font-weight: bold !important;
}
p.middleText {
  font-family: Lato !important;
  font-size: 46px !important;
  font-weight: bold !important;
  margin: -27px 0px -17px 0px;
}
p.supportingText {
  font-size: 30px !important;
  font-weight: 500 !important;
  color: #00bcd4 !important;
}
p.smallHeadingText {
  font-size: 30px !important;
  font-weight: bold !important;
}
p.smallSupportingText {
  font-size: 25px !important;
  font-weight: 500 !important;
  color: #00bcd4 !important;
}

@media (max-width: 960px) {
  .item-shuffle {
    width: 100%;
  }
}

.displayNone {
  visibility: hidden;
}
</style>
